export default __webpack_public_path__ + "static/media/luvitus.e0f2f94c.png";